import React from 'react';
import './Loading.css';

const Loading = ({ message = '' }) => {
    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            {message && <p className="loading-message">{message}</p>}
        </div>
    );
};

export default Loading;
